import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useUI } from "@/context/UIContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { openSellerApp } = useUI();
  const navigate = useNavigate();

  // Temporarily hidden per request — flip to true to bring the nav "Explore" link back.
  const SHOW_EXPLORE_LINK = false;

  return (
    <nav
      data-testid="navbar"
      className="flex items-center justify-between px-6 sm:px-10 py-5 border-b border-[var(--line)] bg-[var(--paper)]/85 backdrop-blur-md sticky top-0 z-40"
    >
      <Logo />
      <div className="flex items-center gap-3 sm:gap-5">
        {SHOW_EXPLORE_LINK && (
          <Link
            to="/explore"
            data-testid="nav-explore"
            className="hidden sm:inline-block text-[14px] font-medium text-[var(--ink2)] hover:text-[var(--ink)] transition-colors"
          >
            Explore
          </Link>
        )}
        {user?.is_seller ? (
          <Link
            to="/seller"
            data-testid="nav-seller-dashboard"
            className="btn btn-ghost btn-sm hidden sm:inline-flex"
          >
            Seller Dashboard
          </Link>
        ) : (
          <button
            onClick={openSellerApp}
            data-testid="nav-become-seller"
            className="btn btn-ghost btn-sm hidden sm:inline-flex"
          >
            Become a Creator
          </button>
        )}
        {user ? (
          <>
            <Link
              to="/library"
              data-testid="nav-library"
              className="hidden sm:inline-block text-[14px] font-medium text-[var(--ink2)] hover:text-[var(--ink)] transition-colors"
            >
              Library
            </Link>
            <span className="hidden md:inline-flex items-center gap-2 text-[12px] mono uppercase tracking-wider text-[var(--ink3)]">
              <span className="w-7 h-7 rounded-full bg-[var(--ink)] text-white grid place-items-center text-[11px] font-bold">
                {user.name?.[0]?.toUpperCase() || "U"}
              </span>
              {user.name?.split(" ")[0]}
            </span>
            <button
              data-testid="nav-logout"
              onClick={async () => { await logout(); navigate("/"); }}
              className="btn btn-ghost btn-sm"
            >
              Log out
            </button>
          </>
        ) : (
          <>
            <Link to="/auth?mode=signin" data-testid="nav-signin" className="btn btn-ghost btn-sm">Log in</Link>
            <Link to="/auth?mode=signup" data-testid="nav-signup" className="btn btn-solid btn-sm">Sign up</Link>
          </>
        )}
      </div>
    </nav>
  );
}
